module.exports = __webpack_public_path__ + "static/media/top-img_3.222a6a9e.png";